export default "__VITE_ASSET__DpZ3NYOM__"